import { createFileRoute, redirect } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';
import { z } from 'zod';

import {
  BILLING_ADMIN_MIN_ROLE,
  getBillingAdminRedirect,
} from '~features/students/ui/student-payment/billing-admin-redirect.helpers';
import { TransactionsTablePage } from '~pages/parents/transactions-table';
import { checkMinRoleValue } from '~shared/utils/role-guard';

function Component() {
  const { parentId } = Route.useSearch();
  return <TransactionsTablePage parentId={parentId} />;
}

const searchSchema = z.object({
  parentId: z.string().min(1, 'Parent is required'),
});

export const Route = createFileRoute(
  '/_auth/_layout/parents/transactions-table',
)({
  component: Component,
  validateSearch: zodValidator(searchSchema),
  beforeLoad: async () => {
    // ENR-3529: family transaction history is Admin+ only.
    const hasAccess = await checkMinRoleValue(BILLING_ADMIN_MIN_ROLE);
    const redirectTarget = getBillingAdminRedirect({
      hasAdminAccess: hasAccess,
    });
    if (redirectTarget?.redirectTo === '/dashboard') {
      return redirect({ to: redirectTarget.redirectTo });
    }
  },
});
